const buttonClick = (props) => {
  if (props.disabled) return null;
  if (props.loading) return null;
  if (props.to) return () => props.history.push(props.to);
  return props.onClick;
};

export default buttonClick;



// WEBPACK FOOTER //
// ./src/components/common/button/button-click.js